
var nav=[
     {title:'走进THM',href:"/",child:[
                                 {title:"公司简介",href:"/thm/about"},
                                 {title:"公司动态",href:"/thm/index/5"},
                                 {title:"企业文化",href:"/thm/index/6"},
                                 {title:"优越环境",href:"/thm/fy/n/9"},
                                 {title:"企业荣誉",href:"/thm/img/n/14"},
                                 {title:"精良设备",href:"/thm/img/n/15"},
                                 {title:"医疗团队",href:"/thm/team/n/16"}
                            ]},
     {title:"健康商城",href:"/mall"},
     {title:"健康研究",href:"/",child:[
                                {title:"体检常识",href:"/hs/index/44"},
                                {title:"健康资讯",href:"/hs/index/45"},
                                {title:"行业资讯",href:"/hs/index/46"},
                                {title:"优惠活动",href:"/hs/index/47"},
     ]},
     {title:"健康管理",href:"/hm"},
     {title:"私人医生",href:"/pd"},
     {title:"会员服务",href:"/user/index"},
     {title:"联系我们",href:"/about"},
     {title:"报告查询",href:"/user/report"},
     {title:"体检预约",href:"/user/book"}
 
 ];



export default nav;


// WEBPACK FOOTER //
// ./src/js/nav.js